import React, { useEffect, useState } from 'react'
import './leaderboard-item.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { getRandomLinearGradient } from '@/utils/randomGradient';
import { useSelector } from 'react-redux';

const LeaderboardItem = ({ 
    leader, 
    index, 
    liveData, 
    levels, 
    badges, 
    playerView 
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ earnedLevel, setEarnedLevel ] = useState(null);

    useEffect(() => {
        if (!levels) return;
        setEarnedLevel(Object.values(levels).sort((a,b) => a.opt_pointMinimum < b.opt_pointMinimum ? 1 : -1)
        .filter(l => l.opt_pointMinimum <= leader.data)[0]);
    }, [levels])
    
    return (
        <div className={`g-list-item leaderboard-item ${leader.animate ? 'jello-horizontal' : ''} ${screenSize}`}>
            <div className='info'>
                <div className='index-div'>
                    {index + 1}
                </div>
                {
                    (liveData.nameDisplay !== 'secret' && leader.icon)
                    ?
                    <ImageContainer src={leader.icon} className='leader-icon' alt='leader-icon' />
                    :
                    (liveData.nameDisplay !== 'secret')
                    ?
                    <div className='gradient-icon' style={{'background': leader.gradient}}>{leader.name[0]}</div>
                    :
                    <div className='gradient-icon' style={{'background': getRandomLinearGradient()}}>{leader.name[0]}</div>
                }
                {
                    (liveData.levels && earnedLevel) &&
                    <ImageContainer src={earnedLevel.icon} alt='level icon' className='icon' title={earnedLevel.name} />
                }
                <div className='name-badges'>
                    <div className='name'>{leader.name}</div>
                    {/* {
                        (badges && liveData.badges && leader.badges) &&
                        <div className='badge-row'>
                            {
                                leader.badges.map(badgeId => (
                                    <div key={badgeId}>
                                        <ImageContainer src={badges[badgeId].icon} alt={badges[badgeId].name + ' badge icon'} title={badges[badgeId].name} className='badge-icon' />
                                    </div>
                                ))
                            }
                        </div>
                    } */}
                </div>
                
            </div>
            <div className='info'>
                {
                    (
                        liveData.totals && 
                        (
                            liveData.data === 'points' || 
                            liveData.data === 'currency' ||
                            liveData.data === 'currencyTotal'
                        )
                    ) &&
                    <>
                        <div className='name'>
                            {
                                (
                                    liveData.indOrTeams === 'teams' &&
                                    liveData.data === 'points' &&
                                    liveData.opt_teamPoints === 'average'
                                )
                                ?
                                leader.data.toLocaleString("en-US", {
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1
                                })
                                :
                                leader.data.toLocaleString("en-US")
                            }
                        </div>
                        {
                            (liveData.data === 'points')
                            ?
                            <ImageContainer src='/images/xp.png' className='icon' />
                            :
                            <ImageContainer src='/images/icons/coins.png' className='icon' />
                        }
                    </>
                }
                {
                    (
                        liveData.totals && 
                        liveData.data === 'change' &&
                        liveData.opt_changeDisplay === 'actual'
                    ) &&
                    <>
                        <div className={`name ${
                            leader.data === 0
                            ?
                            ''
                            :
                            leader.data > 0
                            ?
                            'green'
                            :
                            'red'
                        }`}>
                            {leader.data >= 0 ? '+' : ''}
                            {leader.data}
                        </div>
                        {
                            (liveData.opt_changeElement === 'points')
                            ?
                            <ImageContainer src='/images/xp.png' className='icon' />
                            :
                            <ImageContainer src='/images/icons/coins.png' className='icon' />
                        }
                    </>
                }
                {
                    (
                        liveData.totals && 
                        liveData.data === 'change' &&
                        liveData.opt_changeDisplay === 'percent'
                    ) &&
                    <>
                        <div className={`meta ${
                            leader.actual === 0
                            ?
                            ''
                            :
                            leader.actual > 0
                            ?
                            'green'
                            :
                            'red'
                        }`}>
                            {leader.actual >= 0 ? '+' : ''}
                            {leader.actual}
                        </div>
                        <div className={`${
                            leader.data === 0
                            ?
                            ''
                            :
                            leader.data > 0
                            ?
                            'green'
                            :
                            'red'
                        }`}>{leader.data.toFixed(1)}%</div>
                        {
                            (liveData.opt_changeElement === 'points')
                            ?
                            <ImageContainer src='/images/xp.png' className='icon' />
                            :
                            <ImageContainer src='/images/icons/coins.png' className='icon' />
                        }
                    </>
                }
            </div>
        </div>
    )
}

export default LeaderboardItem